import Anniversary from "../app/screens/customerCRMTrial/anniversary";
import Birthday from "../app/screens/customerCRMTrial/birthday";
import CustomerHome from "../app/screens/customerCRMTrial/home";
import Instragram from "../app/screens/customerCRMTrial/instagram";
import CustomerProducts from "../app/screens/customerCRMTrial/products";
import CustomerProductview from "../app/screens/customerCRMTrial/productview";
import CustomerProfile from "../app/screens/customerCRMTrial/profile";
import Referral from "../app/screens/customerCRMTrial/referral";
import Specialvoucher from "../app/screens/customerCRMTrial/specialvoucher";
import CustomerThankyou from "../app/screens/customerCRMTrial/thank-you";
import Uploaddesignvoucher from "../app/screens/customerCRMTrial/uploaddesignvoucher";
import CustomerWishlist from "../app/screens/customerCRMTrial/wishlist";
export const TrialRoutes = [
  {
    path: "/trial-view/home",
    name: "home",
    icon: "flaticon-web",
    child: false,
    component: CustomerHome,
  },
  {
    path: "/trial-view/products",
    name: "Products",
    icon: "flaticon-web",
    child: false,
    component: CustomerProducts,
  },
  {
    path: "/trial-view/product-view",
    name: "Product View",
    icon: "flaticon-web",
    child: false,
    component: CustomerProductview,
  },
  {
    path: "/trial-view/wish-list",
    name: "wish list",
    icon: "flaticon-web",
    child: false,
    component: CustomerWishlist,
  },
  {
    path: "/trial-view/thank-you",
    name: "thank you",
    icon: "flaticon-web",
    child: false,
    component: CustomerThankyou,
  },
  {
    path: "/trial-view/referral",
    name: "referral",
    icon: "flaticon-web",
    child: false,
    component: Referral,
  },
  {
    path: "/trial-view/birthday",
    name: "birthday",
    icon: "flaticon-web",
    child: false,
    component: Birthday,
  },
  {
    path: "/trial-view/anniversary",
    name: "Anniversary",
    icon: "flaticon-web",
    child: false,
    component: Anniversary,
  },
  {
    path: "/trial-view/instagram",
    name: "Instragram",
    icon: "flaticon-web",
    child: false,
    component: Instragram,
  },
  {
    path: "/trial-view/special-voucher",
    name: "special voucher",
    icon: "flaticon-web",
    child: false,
    component: Specialvoucher,
  },
  {
    path: "/trial-view/upload-design",
    name: "upload design",
    icon: "flaticon-web",
    child: false,
    component: Uploaddesignvoucher,
  },
  {
    path: "/trial-view/profile",
    name: "profile",
    icon: "flaticon-web",
    child: false,
    component: CustomerProfile,
  }
];
